angular.module('unica_room.room_services')

.factory('RoomListService', function($http, getBaseApiURL) {

	var roomListService = {};

	roomListService.list = function (eventId, limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.rooms;
			}

		});
	};

	roomListService.fullList = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/full-list/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.rooms;
			}

		});
	};

	roomListService.search = function (eventId, searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/search/' + eventId,
			data: searchData
		}).then(function(result) {

			if ( result ) {
				return result.data.rooms;
			}

		});
	};

	roomListService.getListGrouped = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/list-grouped/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.rooms;
			}

		});
	};


	roomListService.get = function (roomId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/detail/' + roomId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.room;
			}

		});

	};

	return roomListService;

})
;